export const removeLastCharacter = (string: string) => string.slice(0, -1);